import { Routes, Route } from 'react-router-dom';
import { DailyReportsLandingPage } from './daily-reports-landing-page';
import { DailyReportsListPage } from './daily-reports-list-page';
import { CreateDailyReportPage } from './create-daily-report-page';
import { DailyReportDetailPage } from './daily-report-detail-page';

export function DailyReportsRoutes() {
  return (
    <Routes>
      <Route index element={<DailyReportsLandingPage />} />
      <Route path=":id" element={<DailyReportsListPage />} />
      <Route path=":id/new" element={<CreateDailyReportPage />} />
      <Route path=":id/:reportId/edit" element={<CreateDailyReportPage />} />
      <Route path=":id/:reportId" element={<DailyReportDetailPage />} />
    </Routes>
  );
}
